// shared-designer/src/lib/api.ts · v12.10.3 (BDR-016) · 2026-10-03 · VoiceSpectrum AI
// The shared designer's api: every call goes to the HOST's client (configureDesignerHost). Same shape as T2's lib/api
// (default export + named `api`) so the moved files did not change a line.
import { designerHost } from '../host';

export const api = {
  get:    <T>(path: string, options?: RequestInit) => designerHost().api.get<T>(path, options),
  post:   <T>(path: string, body?: unknown, options?: RequestInit) => designerHost().api.post<T>(path, body, options),
  put:    <T>(path: string, body?: unknown, options?: RequestInit) => designerHost().api.put<T>(path, body, options),
  patch:  <T>(path: string, body?: unknown, options?: RequestInit) => designerHost().api.patch<T>(path, body, options),
  delete: <T>(path: string, options?: RequestInit) => designerHost().api.delete<T>(path, options),
};

export default api;
